import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { useActionBarContribution, type ActionBarAction } from '~components';
import FormDialog from '~components/dialogs/formDialog';
import { StatusVariant } from '~enums';

import EditUserForm, { EditUserFormResults } from '../forms/editUserForm';

interface Props {
	showInviteUserButton: boolean;
	showInviteUserForm: boolean;
	isInvitingUser: boolean;
	onInviteUserButtonClicked: () => void;
	onInviteUser: (formData: EditUserFormResults) => void;
	onCancel: () => void;
}

const UsersActionBar = ({
	showInviteUserButton,
	showInviteUserForm,
	isInvitingUser,
	onInviteUserButtonClicked,
	onInviteUser,
	onCancel,
}: Props) => {
	const { t } = useTranslation();

	const actions = useMemo<ActionBarAction[]>(() => {
		const list: ActionBarAction[] = [
			...(showInviteUserButton ?
				[
					{
						id: `invite-user`,
						label: t('user.labels.inviteUser', { ns: 'entities' }),
						variant: StatusVariant.Brand,
						onClick: () => onInviteUserButtonClicked(),
					},
				]
			:	[]),
		];
		return list;
	}, [t]);

	useActionBarContribution(actions, { id: `users-actions` });

	return (
		<>
			<FormDialog
				open={showInviteUserForm}
				title={t('user.labels.inviteUser', { ns: 'entities' })}
				loading={isInvitingUser}
			>
				<EditUserForm
					allowRoleEditing
					includeEmailField
					onSubmit={async (formData) => onInviteUser(formData)}
					onCancel={onCancel}
				/>
			</FormDialog>
		</>
	);
};

export default UsersActionBar;
